<template>
  <v-card v-if="isSubscriber" class="mb-4 community-card" dark>
    <v-card-text class="pa-6">
      <div class="community-tag mb-1">
        @psicoplanner.app <span class="divider">|</span>
        Aplicativo para <b>psicólogas</b>
      </div>

      <div class="hero">
        <div class="hero-text">
          <h2 class="community-heading">Comunidade</h2>
          <div class="community-brand">psicoplanner</div>

          <div class="rule-row my-4">
            <div class="line"></div>
            <div class="dot"></div>
            <div class="line"></div>
          </div>

          <p class="community-text">
            Um espaço para psicólogas que querem crescer com mais clareza na
            clínica, com conversas sobre <b>marketing, negócios,</b>
            <span class="em-purple">gestão e posicionamento profissional.</span>
          </p>

          <a class="cta mt-4" @click.prevent="joinCommunity()">
            Entrar na comunidade
            <span class="arrow">
              <v-icon color="primary" small>mdi-arrow-right</v-icon>
            </span>
          </a>
        </div>

        <img class="community-photo" src="/img/image_banner.png" alt="Comunidade Psicoplanner" />
      </div>

      <div class="features my-5">
        <div v-for="feature in features" :key="feature.title" class="feature">
          <div class="icon">
            <v-icon small color="white">{{ feature.icon }}</v-icon>
          </div>
          <div class="label">
            <b>{{ feature.title }}</b>
            <span>{{ feature.subtitle }}</span>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      features: [
        { icon: "mdi-bullhorn", title: "Marketing", subtitle: "para psicólogas" },
        { icon: "mdi-clipboard-text", title: "Gestão", subtitle: "e rotina clínica" },
        { icon: "mdi-target", title: "Negócios", subtitle: "e posicionamento" },
        { icon: "mdi-account-group", title: "Estratégia", subtitle: "apoio e evolução" },
      ],
    };
  },

  computed: {
    isSubscriber() {
      return this.$store.getters["subscription/hasActiveSubscription"];
    },
  },

  methods: {
    joinCommunity() {
      window.open("https://chat.whatsapp.com/ERXnKztfhqcEuU3HCrHSOV?mode=gi_t");
    },
  },
};
</script>

<style scoped>
.community-card {
  border-radius: 20px !important;
  background: radial-gradient(circle at 80% 15%, rgba(140, 158, 255, 0.3), transparent 45%),
    radial-gradient(circle at 10% 90%, rgba(98, 77, 227, 0.5), transparent 50%),
    linear-gradient(135deg, #1d1548 0%, #2a1e66 60%, #33267a 100%);
}

.community-tag {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
  text-align: right;
}

.community-tag .divider {
  opacity: 0.4;
  margin: 0 4px;
}

.community-tag b {
  background: linear-gradient(90deg, #a390ff, #8c9eff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.community-heading {
  font-size: 28px;
  line-height: 1.1;
  font-weight: 700;
  color: #fff;
}

.community-brand {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.1;
  background: linear-gradient(90deg, #b3a5ff, #7c68ee 35%, #8c9eff 80%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.rule-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.rule-row .line {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, rgba(98, 77, 227, 0.8), rgba(140, 158, 255, 0.8));
}

.rule-row .dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: linear-gradient(135deg, #624de3, #8c9eff);
}

.community-text {
  font-size: 14px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0;
}

.community-text b {
  color: #aebcff;
  font-weight: 600;
}

.community-text .em-purple {
  color: #b3a5ff;
  font-weight: 600;
}

.hero {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 14px;
  align-items: center;
}

.community-photo {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 16px;
}

.features {
  background: rgba(20, 14, 58, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 16px 18px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.feature {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.feature .icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  flex-shrink: 0;
  background: radial-gradient(circle at 35% 30%, #7c68ee, #4534a8 70%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.15);
}

.feature .label b {
  display: block;
  color: #aebcff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
}

.feature .label span {
  color: rgba(255, 255, 255, 0.7);
  font-size: 11.5px;
  line-height: 1.3;
}

.cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  background: linear-gradient(90deg, #624de3, #8c9eff);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  padding: 10px 8px 10px 20px;
  border-radius: 32px;
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 8px 22px rgba(98, 77, 227, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(98, 77, 227, 0.5);
}

.cta .arrow {
  background: #fff;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

@media (max-width: 600px) {
  .hero {
    grid-template-columns: 1fr;
  }

  .features {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
